<template>
	<div class="login-view">
		<div class="header">
			<img src="../../assets/img-v2/ic_login_back.png" alt="返回" class="back" @click="onClickBack" />
			<img src="../../assets/img-v2/ic_login_bg.png" class="bg" />
			<img :src="loginLogoUrl" class="logo"/>
			<div class="title">{{ loginTitle }}</div>
		</div>
		<div class="box">
			<div class="row">
				<img src="../../assets/img-v2/ic_login_phone.png" class="icon" />
				<div class="label">手机号</div>
			</div>
			<div class="form">
				<input type="tel" v-model="mobile" placeholder="请输入手机号" class="input" />
			</div>
			<div class="row">
				<img src="../../assets/img-v2/ic_login_code.png" class="icon" />
				<div class="label">验证码</div>
			</div>
			<div class="form">
				<input v-model="code" type="number" placeholder="请输入验证码" class="input" />
				<div class="code" :class="{'disabled': codeBtnDisabled}" @click="onClickCode">{{countdown > 0 ? `${countdown}s` : '获取验证码'}}</div>
			</div>
			<VanButton class="submit" :disabled="submitBtnDisabled" @click="onSubmit">立即登录</VanButton>
			<div v-if="enableVoiceCode" class="voice" :class="{ 'disabled': voiceCodeBtnDisabled }" @click="onVoice">收不到验证码，试试语音验证</div>
		</div>

		<div v-if="clientContext || privacyContext" class="bottom">
			<img v-if="isAgree" src="../../assets/img-v2/ic_checkbox_selected.png" class="checkbox" @click="onSelect" />
			<img v-else src="../../assets/img-v2/ic_checkbox.png" class="checkbox" @click="onSelect" />
			<span>我已阅读并同意</span>
			<span v-if="privacyContext" class="blue" @click="onOpenPrivacy">&nbsp;隐私协议</span>
			<span v-if="clientContext && privacyContext">&nbsp;和&nbsp;</span>
			<span v-if="clientContext" class="blue" @click="onOpenClient">用户协议&nbsp;</span>
		</div>

		<ProtocolDialog
			v-model="isShowProtocol" 
			:content="protocolContent"
			@confirm="onConfirm"
		/>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
import {delay} from "../../utils";
import ProtocolDialog from './components/ProtocolDialog.vue';
const COUNTDOWN = 60;
let timer;
export default {
	name: 'Login',
	components: {
		ProtocolDialog
	},
	data() {
		return {
			mobile: '',
			code: '',
			isAgree: false,
			isShowProtocol: false,
			protocolContent: '',
		};
	},
	computed: {
		...mapGetters({
			countdown: 'user/captchaCountdown',
      ticketConfig: 'config/ticketConfig',
      enableVoiceCode: 'config/enableVoiceCode'
		}),

		isMobileValid() {
			return /^1\d{10}$/.test(this.mobile.trim());
		},
		isCodeValid() {
			return /\d{4,6}/.test(this.code.trim());
		},
		codeBtnDisabled() {
			return !this.isMobileValid || this.countdown > 0;
		},
		voiceCodeBtnDisabled() {
			return !this.isMobileValid;
		},
		submitBtnDisabled() {
			return !this.isMobileValid  || !this.agreeProtocol;
		},
		fromRoute() {
			const {from} = this.$route.params;
			return from;
		},
		cityId() {
      return this.$AppService.getCityId()
    },
		loginTitle() {
			const { loginTitle } = this.ticketConfig || {};
			return loginTitle || '登录';
		},
		loginLogoUrl() {
			const { loginLogoUrl } = this.ticketConfig || {};
			return loginLogoUrl || require('../../assets/img-v2/ic_login_logo.png');
		},
		clientContext() {
			const { clientContext } = this.ticketConfig || {};
			return clientContext;
		},
		privacyContext() {
			const { privacyContext } = this.ticketConfig || {};
			return privacyContext;
		},
		agreeProtocol() {
			const { clientContext, privacyContext } = this.ticketConfig || {};
			if (clientContext || privacyContext) {
				return this.isAgree
			}
			return true
		},
		protocolToastDesc() {
			const { clientContext, privacyContext } = this.ticketConfig || {};
			if (clientContext && privacyContext) {
				return '请先同意用户协议和隐私协议'
			} else if (clientContext) {
				return '请先同意用户协议'
			} else if (privacyContext) {
				return '请先同意隐私协议'
			}
			return ''
		}
	},
	activated() {
		this.clearForm();
	},
	beforeRouteLeave (to, from, next) {
		this.clearTimer();
		next();
	},
	methods: {
		clearForm() {
			this.mobile = '';
			this.code = '';
		},
		onClickBack() {
			this.goBack(true);
		},
		goBack(isManual = false) {
			try {
				if (this.fromRoute) {
					if (isManual) {
						this.$HomeService.turnToHomeView();
					} else {
						this.$router.replace(this.fromRoute);
					}
				} else {
					if (window.history.length > 1) {
						this.$router.back();
					} else {
						this.$HomeService.turnToHomeView();
					}
				}
			} catch (err) {
				console.log('[登录页] 回跳失败，即将进入首页', err);
				this.$HomeService.turnToHomeView();
			}
		},
		onClickCode() {
			if (this.codeBtnDisabled) {
				return;
			}
			if (!this.agreeProtocol) {
				this.$toast(this.protocolToastDesc);
				return;
			}
			this.startTimer();
			this.$UserService.sendCaptcha({
				mobile: this.mobile
			}).then(() => {
				this.$toast('已发送');
			});
		},
		onSubmit() {
			if (this.submitBtnDisabled) {
				return;
			}
			if (!this.isCodeValid) {
				this.$toast('请输入正确的验证码');
				return;
			}
			this.$UserService.bindMobile({
				mobile: this.mobile,
				code: this.code
			}).then((data) => {
				this.$toast({message: '登录成功', timeout: 2000});
				this.$UserService.setUser(data);
				delay(() => {
					this.$UserService.setCaptchaCountdown(0);
					if (timer) {
						clearInterval(timer);
						timer = null;
					}
					this.goBack();
				}, 2000);
				delay(() => {
					window.location.reload();
				}, 3000);
			}).catch((err) => {
				this.$toast(err.msg || '出现错误');
			});
		},
		onSelect() {
			this.isAgree = !this.isAgree;
		},
		onConfirm() {
			this.isAgree = true;
		},
		onOpenPrivacy() {
			this.protocolContent = this.privacyContext;
			this.isShowProtocol = true;
		},
		onOpenClient() {
			this.protocolContent = this.clientContext;
			this.isShowProtocol = true;
		},
		startTimer() {
			this.stopTimer();
			this.$UserService.setCaptchaCountdown(COUNTDOWN);
			timer = setInterval(() => {
				this.$UserService.setCaptchaCountdown(this.countdown - 1);
				if (this.countdown === 0) {
					clearInterval(timer);
					timer = null;
				}
			}, 1000);
		},
		stopTimer() {
			if (timer) {
				clearInterval(timer);
				timer = null;
				this.$UserService.setCaptchaCountdown(0);
			}
		},
		clearTimer() {
			this.stopTimer()
			this.$UserService.setCaptchaCountdown(0);
		},
		onVoice() {
			if (!this.isMobileValid) return
			if (this.codeBtnDisabled) {
				this.$toast('操作频繁，请稍后再试');
				return;
			}
			if (!this.agreeProtocol) {
				this.$toast(this.protocolToastDesc);
				return;
			}
			this.startTimer();
			this.$UserService.sendVoiceCaptcha({
				mobile: this.mobile
			}).then(() => {
				this.$toast('验证码已下发，请注意接听电话，如未接到电话，请检查是否设置了骚扰电话的拦截！');
			}).catch(err => {
				if (err && err.errmsg) {
					this.$toast(err.errmsg);
				}
			})
		}
	}
};
</script>

<style scoped lang="scss">
	.login-view {
		height: 100vh;
		z-index: 100;
		display: flex;
		flex-direction: column;
		.header {
			position: relative;
			padding: 66px 0 50px 0;
			display: flex;
			flex-direction: column;
			align-items: center;
			background: linear-gradient( 180deg, #A7D2FF 0%, #89C3FF 0%, #FFFFFF 100%), linear-gradient( 222deg, #D9FFF3 0%, rgba(255,255,255,0) 100%);
		}
		.back {
			width: 38px;
			height: 38px;
			position: absolute;
			left: 10px;
			top: 10px;
			z-index: 1;
		}
		.bg {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
		}
		.logo {
			width: 60px;
			height: 60px;
			position: relative;
			border-radius: 20px;
		}
		.title {
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 22px;
			color: #000000;
			line-height: 22px;
			margin-top: 20px;
			position: relative;
		}
		.box {
			flex: 1;
			padding: 30px 20px 0 20px;
			border-radius: 28px 28px 0px 0px;
			background: #FFFFFF;
			transform: translateY(-20px);
		}

		.row {
			display: flex;
			align-items: center;
			margin-bottom: 16px;
		}
		.icon {
			width: 20px;
			height: 20px;
			margin-right: 4px;
		}
		.label {
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 16px;
			color: #000000;
			line-height: 24px;
		}
		.form {
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #EEEEEE;
			margin-bottom: 20px;
			padding-bottom: 11px;
		}
		.input {
			flex: 1;
			border: none;
			outline: none;
			padding: 0;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
			line-height: 22px;
			padding-left: 2px;
			&::placeholder {
				color: #9599A3;
			}
		}
		.code {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: #006EFA;
			line-height: 22px;
		}

		.submit {
			width: 100%;
			height: 48px;
			border: none;
			border-radius: 32px;
			background: linear-gradient( 90deg, #00A7FD 0%, #006EFA 100%);
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 18px;
			color: #FFFFFF;
			line-height: 25px;
			box-shadow: 0px 2px 8px 0px #5A85B9;
		}
		.voice {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #006EFA;
			line-height: 20px;
			text-align: center;
			margin-top: 20px;
		}
		.bottom {
			padding-bottom: calc(30px + constant(safe-area-inset-bottom));
			padding-bottom: calc(30px + env(safe-area-inset-bottom));
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #7C818E;
			line-height: 20px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.checkbox {
			width: 16px;
			height: 16px;
		}
		.blue {
			color: #006EFA;
		}
		.disabled {
			color: #9599A3;
		}
	}
</style>
